export class BackgroundDataEvent
{
    static COLOR_CHANGED: string = "BackgroundDataEvent.COLOR_CHANGED";
    static IMAGE_CHANGED: string = "BackgroundDataEvent.IMAGE_CHANGED";
    static PATTERN_CHANGED: string = "BackgroundDataEvent.PATTERN_CHANGED";
    static WIDTH_CHANGED: string = "BackgroundDataEvent.WIDTH_CHANGED";
    static HEIGHT_CHANGED: string = "BackgroundDataEvent.HEIGHT_CHANGED";

}
